/* eslint-disable */
import '../../static/libs/chess.js'

var engine;
var funcCallMove;

function engineGame(options) {
    options = options || {}
    var game = new Chess();
    // var board;
    mostrarMensaje("Arrancando el motor de ajedrez.");
    var wasmSupported = typeof WebAssembly === 'object' && WebAssembly.validate(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
    console.log ('wasmsupport: ' + wasmSupported );
    try { var engine = new Worker(wasmSupported ? 'static/libs/stockfish.wasm.js' : options.stockfishjs || 'static/libs/stockfish.js'); }
    catch(err) { return null; }
    //engine = new Worker(options.stockfishjs || 'static/libs/stockfish.js');
    var engineStatus = {};
    var displayScore = false;
    var time = { wtime: 300000, btime: 300000, winc: 2000, binc: 2000, depth: 10,  };
    var playerColor = 'white';
    var clockTimeoutID = null;
    var isEngineRunning = false;

    // do not pick up pieces if the game is over
    // only pick up pieces for White
    /* var onDragStart = function(source, piece, position, orientation) {
        var re = playerColor == 'white' ? /^b/ : /^w/
            if (game.game_over() ||
                piece.search(re) !== -1) {
                return false;
            }
    };*/

    function uciCmd(cmd) {
        engine.postMessage(cmd);
    }
    uciCmd('uci');
    
    // Evaluation engine
    function mostrarMensaje(texto) {
        // Crear el elemento del mensaje dinámicamente
        const mensaje = document.createElement('div');
        mensaje.textContent = texto; // Establecer el texto del mensaje
        mensaje.style.position = 'fixed';
        mensaje.style.top = '50px';
        mensaje.style.left = '50%';
        mensaje.style.transform = 'translateX(-50%)';
        mensaje.style.backgroundColor = '#5c005c';
        mensaje.style.color = '#fff';
        mensaje.style.padding = '10px 20px';
        mensaje.style.border = '1px solid #ccc';
        mensaje.style.borderRadius = '5px';
        mensaje.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        mensaje.style.zIndex = '1000';
    
        // Agregar el mensaje al cuerpo del documento
        document.body.appendChild(mensaje);
    
        // Eliminar el mensaje después de 3 segundos
        setTimeout(() => {
            mensaje.remove(); // Elimina el mensaje del DOM
        }, 2000); // 3000 milisegundos = 3 segundos
    }

    function displayStatus() {
        var status = 'Motor: ';
        if(!engineStatus.engineLoaded) {
            status += 'cargando ...';
        } else if(!engineStatus.engineReady) {
            status += 'cargado.';
        } else {
            status += 'listo.';
        }
        /* if (typeof engineStatus.book !== 'undefined') 
        {
            status += ' Libro de aperturas: ' + engineStatus.book;
        }*/
        // window.alert(status)
        if(engineStatus.search) {
            status += '<br>' + engineStatus.search;
            if(engineStatus.score && displayScore) {
                status += ' Puntos: ' + engineStatus.score;
            }
        }
        var evalStatus = document.getElementById('eval');
        if (evalStatus != undefined) {
            evalStatus.innerHTML = status
        }
    }

    function displayClock(color, t) {
        var isRunning = false;
        if(time.startTime > 0 && color == time.clockColor) {
            t = Math.max(0, t + time.startTime - Date.now());
            isRunning = true;
        }
        var id = color == playerColor ? '#time2' : '#time1';
        var sec = Math.ceil(t / 1000);
        var min = Math.floor(sec / 60);
        sec -= min * 60;
        var hours = Math.floor(min / 60);
        min -= hours * 60;
        var display = hours + ':' + ('0' + min).slice(-2) + ':' + ('0' + sec).slice(-2);
        if(isRunning) {
            display += sec & 1 ? ' <--' : ' <-';
        }
        // $(id).text(display);
    }

    function updateClock() {
        // window.alert('update')
        displayClock('white', time.wtime);
        displayClock('black', time.btime);
    }

    function clockTick() {
        updateClock();
        var t = (time.clockColor == 'white' ? time.wtime : time.btime) + time.startTime - Date.now();
        var timeToNextSecond = (t % 1000) + 1;
        clockTimeoutID = setTimeout(clockTick, timeToNextSecond);
    }

    function stopClock() {
        // window.alert('stop')
        if(clockTimeoutID !== null) {
            clearTimeout(clockTimeoutID);
            clockTimeoutID = null;
        }
        if(time.startTime > 0) {
            var elapsed = Date.now() - time.startTime;
            time.startTime = null;
            if(time.clockColor == 'white') {
                time.wtime = Math.max(0, time.wtime - elapsed);
            } else {
                time.btime = Math.max(0, time.btime - elapsed);
            }
        }
    }

    function startClock() {
        // window.alert('start')
        if(game.turn() == 'w') {
            time.wtime += time.winc;
            time.clockColor = 'white';
        } else {
            time.btime += time.binc;
            time.clockColor = 'black';
        }
        time.startTime = Date.now();
        clockTick();
    }

    function prepareMove(fen, pgn, funcCall, wtime, btime, winc, binc) {
        funcCallMove = funcCall
        stopClock();
        // $('#pgn').text(game.pgn());
        // board.position(game.fen());
        if (pgn.length > 0) {
            game.load_pgn(pgn)
        } else if (fen.length > 0) {
            // window.alert(fen)
            game.load(fen);
        }
        // window.alert('init')
        updateClock();
        var turn = game.turn() == 'w' ? 'white' : 'black';
        // window.alert(turn + ' ' + playerColor);
        if(!game.game_over()) {
             if(turn != playerColor) {
                var moves = '';
                if (pgn.length > 0) {
                    var history = game.history({verbose: true});
                    for(var i = 0; i < history.length; ++i) {
                        var move = history[i];
                        moves += ' ' + move.from + move.to + (move.promotion ? move.promotion : '');
                    }
                    uciCmd('position startpos moves' + moves);
                } else {
                    uciCmd('position fen ' + fen);
                }
                if(time.depth) {
                    uciCmd('go depth ' + time.depth);
                } else if(time.nodes) {
                    uciCmd('go nodes ' + time.nodes);
                } else  {
                    // window.alert(wtime + '-' + winc + '-' + btime + '-' + binc);
                    if (wtime < 60000 || btime < 60000) {
                        uciCmd('go wtime ' + wtime + ' winc ' + winc + ' btime ' + btime + ' binc ' + binc);
                        // uciCmd('go wtime ' + wtime + ' btime ' + btime + ' winc' + winc + ' binc' + binc);
                        // uciCmd('go depth ' + 20);
                    } else {
                        uciCmd('go movetime 3000');
                    }
                }
                isEngineRunning = true;
                startClock();
              }
              // if(game.history().length >= 2 && !time.depth && !time.nodes) {
                // startClock();
            //}
        }
    }

    engine.onmessage = function(event) {
        var line = event.data;
        if (engineStatus.engineReady == false) {
            console.log(line);
        }
        // engineStatus.engineReady = line;
        if(line == 'uciok') {
            engineStatus.engineLoaded = true;
        } else if(line == 'readyok') {
            engineStatus.engineReady = true;
        } else {
            var match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbk])?/);
            if(match) {
                isEngineRunning = false;
                game.move({from: match[1], to: match[2], promotion: match[3]});
                // window.alert(JSON.stringify({from: match[1], to: match[2], promotion: match[3]}));
                funcCallMove({from: match[1], to: match[2], promotion: match[3]})
                // prepareMove();
            } else if(match = line.match(/^info .*\bdepth (\d+) .*\bnps (\d+)/)) {
                engineStatus.search = 'Profundidad: ' + match[1] + ' Nps: ' + match[2];
            }
            if(match = line.match(/^info .*\bscore (\w+) (-?\d+)/)) {
                var score = parseInt(match[2]) * (game.turn() == 'w' ? 1 : -1);
                if(match[1] == 'cp') {
                    engineStatus.score = (score / 100.0).toFixed(2);
                } else if(match[1] == 'mate') {
                    engineStatus.score = '#' + score;
                }
                if(match = line.match(/\b(upper|lower)bound\b/)) {
                    engineStatus.score = ((match[1] == 'upper') == (game.turn() == 'w') ? '<= ' : '>= ') + engineStatus.score
                }
            }
        }
        displayStatus();
    };

    /*var onDrop = function(source, target) {
        // see if the move is legal
        var move = game.move({
            from: source,
            to: target,
            promotion: 'q' // NOTE: always promote to a pawn for example simplicity
        });

        // illegal move
        if (move === null) return 'snapback';

        prepareMove();
    };*/

    // update the board position after the piece snap
    // for castling, en passant, pawn promotion
    /* var onSnapEnd = function() {
        // board.position(game.fen());
    };*/
/*
    var cfg = {
        draggable: true,
        position: 'start',
        onDragStart: onDragStart,
        onDrop: onDrop,
        onSnapEnd: onSnapEnd
    };
*/
    if(options.book) {
        var bookRequest = new XMLHttpRequest();
        bookRequest.open('GET', options.book, true);
        bookRequest.responseType = "arraybuffer";
        bookRequest.onload = function(event) {
            if(bookRequest.status == 200) {
                engine.postMessage({book: bookRequest.response});
                engineStatus.book = options.book;
                displayStatus();
            } else {
                engineStatus.book = 'No exite.';
                displayStatus();
            }
        };
        bookRequest.send(null);
    } else {
        engineStatus.book = 'none';
    }

    // board = new ChessBoard('board', cfg);

    return {
        reset: function() {
            game.reset();
            // window.alert('reset')
            uciCmd('setoption name Contempt Factor value 0');
            uciCmd('setoption name Skill Level value 10');
            uciCmd('setoption name Aggressiveness value 100');
            uciCmd('setoption name OwnBook value false');
        },
        setOwnBook: function(value) {
            uciCmd('setoption name OwnBook value ' + value);
        },
        loadPgn: function(pgn) { game.load_pgn(pgn); },
        setPlayerColor: function(color) {
            playerColor = color;
            // board.orientation(playerColor);
        },
        setSkillLevel: function(skill) {
            uciCmd('setoption name Skill Level value ' + skill);
            // window.alert('setoption name Skill Level value ' + skill);
        },
        setTime: function(baseTime, inc) {
            time = { wtime: baseTime * 1000, btime: baseTime * 1000, winc: inc * 1000, binc: inc * 1000 };
        },
        setDepth: function(depth) {
            time = { depth: depth };
        },
        setNodes: function(nodes) {
            time = { nodes: nodes };
        },
        setContempt: function(contempt) {
            uciCmd('setoption name Contempt Factor value ' + contempt);
        },
        setAggressiveness: function(value) {
            uciCmd('setoption name Aggressiveness value ' + value);
        },
        setDisplayScore: function(flag) {
            displayScore = flag;
            displayStatus();
        },
        start: function() {
            uciCmd('ucinewgame');
            uciCmd('isready');
            engineStatus.engineReady = false;
            engineStatus.search = null;
            displayStatus();
            // prepareMove();
        },
        close: function() {
            uciCmd('stop');
            engineStatus.engineReady = false;
            engineStatus.search = null;
            engine.terminate();
            mostrarMensaje("Liberando el motor de ajedrez");
        },
        prepareMove: function(fen, pgn, funcCall, wtime, btime, winc, binc) {
            prepareMove(fen, pgn, funcCall, wtime, btime, winc, binc);
        },
        undo: function() {
            if(isEngineRunning)
                return false;
            game.undo();
            game.undo();
            engineStatus.search = null;
            displayStatus();
            //prepareMove();
            return true;
        }
    };
}

module.exports.engineGame = engineGame




// WEBPACK FOOTER //
// ./src/services/enginegame.js